import "./styles/quasar.scss";
import iconSet from "quasar/icon-set/fontawesome-v5.js";

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: ["Notify"],
  iconSet: iconSet,
};
